import API from "@/models/API";

export default class PointTitles {
    constructor(item = {}) {
        this.store_point_title_id = item.store_point_title_id || null;
        this.from = item.from || null;
        this.to = item.to || null;
        this.multiplier = item.multiplier || null;
        this.color = item.color || "";
        this.title = item.title || {
            en: "",
            el: "",
            it: ""
        }
        this.description = item.description || {
            en: "",
            el: "",
            it: ""
        }
    }

    static get = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/point-titles`);

    static create = (body) =>
        API.post(`/companies/${localStorage.getItem("storeId")}/point-titles`,body);

    static update = (body) =>
        API.put(`/companies/${localStorage.getItem("storeId")}/point-titles`,body);

    static delete = () =>
        API.delete(`/companies/${localStorage.getItem("storeId")}/point-titles`);
        
}
